
const todo = {
    state: {
        todo: '' 
    },
    mutations: {
        SET_TODO: (state,v) => {
            state.todo = v
        }
    },
    actions: {
        SET_TODO(context,v){
            context.commit("SET_TODO",v);
        }
        
    }
}

export default todo
